<template>
	<div class="base-overlay" @click.self="$emit('close')">
		<slot />
	</div>
</template>

<script>
export default {
	emits: ['close'],
	mounted() {
		window.addEventListener('keydown', this.onKeyDown)
	},
	beforeUnmount() {
		window.removeEventListener('keydown', this.onKeyDown)
	},
	methods: {
		onKeyDown(event) {
			if (event.key === 'Escape') {
				this.$emit('close')
			}
		},
	},
}
</script>

<style scoped>
.base-overlay {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5) !important;
	z-index: 20;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: default;
}

/* Don't center the overlay content on screens with high viewport */
@media screen and (min-height: 995px) {
	.base-overlay {
		align-items: start;
		padding-top: 20vh;
	}
}
</style>
